import api from "../api";

class accessService {
  async get() {
    return await api.get("/DashBoard/Access");
  }
}

export default new accessService();